<rma-navigation-header redirectUrl="/manage-account/billing" />

<ng-container *transloco="let t; prefix: 'subscriptions.billing.confirmPause'">
  <mat-card class="mx-auto my-20 w-full max-w-2xl p-10">
    <h1 class="text-heading-2">{{ t('heading') }}</h1>

    <div class="my-6">
      <ul class="flex flex-col gap-3">
        <li class="flex items-center gap-4 text-steel-70">
          <rma-icon [rounded]="true" size="normal" glyph="pause_circle" theme="primary" />
          <p [innerHTML]="t('cycleEnds', { subscriptionPausesOn: subscriptionEnd$ | async | date })"></p>
        </li>
        <li class="flex items-center gap-4 text-steel-70">
          <rma-icon [rounded]="true" size="normal" glyph="arrow_forward" theme="primary" />
          <p [innerHTML]="t('billing', { billingCommencesOn: resumesAt$ | async | date })"></p>
        </li>
        <li class="flex items-center gap-4 text-steel-70">
          <rma-icon [rounded]="true" size="normal" glyph="thumb_up" theme="primary" />
          <p [innerHTML]="t('continue')"></p>
        </li>
      </ul>
    </div>

    @if (isPaused$ | async) {
      <rma-callout class="mb-6" [title]="t('paused.heading')" theme="success">
        <div [innerHtml]="t('paused.description')"></div>
      </rma-callout>
      <div class="text-right">
        <a [routerLink]="'/manage-account/billing'" mat-flat-button color="primary">{{ t('paused.view') }}</a>
      </div>
    } @else {
      <div class="flex justify-between">
        <a [routerLink]="'/manage-account/billing'" color="primary" mat-button>{{ t('cancel') }}</a>
        <button type="button" (click)="handleConfirmPause()" mat-flat-button color="primary">{{ t('confirm') }}</button>
      </div>
    }
  </mat-card>
</ng-container>
